export default __webpack_public_path__ + "static/media/node.0dd35539.png";